import { Element } from "@xmpp/xml"
import { RouteAlertConfig } from "../api/adHocCommands"
import PubSubEventParser from "./PubSubEventParser"

type RouteAlertConfigWithJid = RouteAlertConfig & {
  jid: string
}

class RouteAlertConfigParser {
  static readonly NAMESPACE = "urn:slickshift:account:route-alert-config:0"

  static parse(stanza: Element): RouteAlertConfigWithJid | undefined {
    const item = stanza?.getChild("route-alert-config", this.NAMESPACE)

    if (!item) return

    return {
      jid: stanza.getAttr("id"),
      temperature_main_alert_level_min:
        item.getAttr("temperature-main-alert-level-min") || undefined,
      temperature_main_alert_level_max:
        item.getAttr("temperature-main-alert-level-max") || undefined,
      temperature_additional_alert_level_min:
        item.getAttr("temperature-additional-alert-level-min") || undefined,
      temperature_additional_alert_level_max:
        item.getAttr("temperature-additional-alert-level-max") || undefined,
    }
  }
}

export const RouteAlertConfigPubSubParser =
  new PubSubEventParser<RouteAlertConfigWithJid>(
    RouteAlertConfigParser.parse,
    RouteAlertConfigParser.NAMESPACE,
  )
